import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for fetching carousel data from API
export const fetchCarouselData = createAsyncThunk(
  'frontPage/fetchCarouselData',
  async () => {
    const response = await fetch('/api/carousel');
    return response.json();
  }
);

const frontPageSlice = createSlice({
  name: 'frontPage',
  initialState: {
    slides: [
      {
        id: 1,
        color: "#007bff",
        image: "./pimages/img_axl/01_carousel/600_q40_txt.png",
        imageDesktop: "./pimages/img_axl/01_carousel/600_q40.png",
        clink: "https://blog.xtalball.com/new-tech-exhibition-2026-israel/",
        imageTxt: "Successful presentation 1",
        span: "You are welcome to visit our booth 90 at New-TECH 2026 in Tel-Aviv on 30 June - 1 July",    //You are welcome at our booth #90 on 30 June - 1 July
        title: "",  //You are welcome to visit our booth 90 at New-TECH 2026 in Tel-Aviv on 30 June - 1 July
        description: "Amsterdam", //You are welcome to visit our booth 90 at New-TECH 2026 in Tel-Aviv
        cta: "Learn More",
      },       
      {
        id: 2,
        color: "#ff5733",
        image: "./pimages/img_axl/01_carousel/600_q10_txt.png",
        imageDesktop: "./pimages/img_axl/01_carousel/600_q10.png",
        clink: "https://blog.xtalball.com/ocxo-comprehensive-article-on-observations/",
        imageTxt: "Ultra stable frequency and time reference",
        span: "Ultra stable frequency and time reference",
        title: "",
        description: "...",
        cta: "Get Started",
      },
      {
        id: 3,
        color: "#28a745",
        image: "./pimages/img_axl/01_carousel/600_qc15_txt.png",
        imageDesktop: "./pimages/img_axl/01_carousel/600_qc15_txt.png",
        clink: "https://blog.xtalball.com/ultra-stable-low-power-ocxos-as-a-csac-alternative/",
        imageTxt: "CSAС replacement",
        span: "CSAС alternative and full replacement",
        title: "",
        description: "...",
        cta: "Explore Now",
      },
      {
        id: 4,
        color: "#007bff",
        image: "./pimages/img_axl/01_carousel/600_q35_txt.png",
        imageDesktop: "./pimages/img_axl/01_carousel/600_q35_txt.png",
        clink: "https://blog.xtalball.com/category/news/",
        imageTxt: "Successful presentation 2",
        span: "Successful presentation at European and Asian Electronics Shows",    
        title: "",
        description: "Amsterdam",
        cta: "Learn More",
      },       
      {
        id: 5,
        color: "#28a745",
        image: "./pimages/img_axl/01_carousel/600_q20_txt.png",
        imageDesktop: "./pimages/img_axl/01_carousel/600_q20.png",
        clink: "https://blog.xtalball.com/al-research-oven-controlled-crystal-oscillators-ocxos/",
        imageTxt: "Ideal timing for ocean bottom nodes",
        span: "Ideal timing for ocean bottom nodes",
        title: "",
        description: "...",
        cta: "Explore Now",
      },



    ],
    currentSlide: 0,
    isMenuOpen: false,
    loading: false,
    error: null,
  },
  reducers: {
    setCurrentSlide: (state, action) => {
      state.currentSlide = action.payload;
    },
    nextSlide: (state) => {
      state.currentSlide = (state.currentSlide + 1) % state.slides.length;
    },
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    closeMenu: (state) => {
      state.isMenuOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCarouselData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCarouselData.fulfilled, (state, action) => {
        state.loading = false;
        state.slides = action.payload;
      })
      .addCase(fetchCarouselData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setCurrentSlide, nextSlide, toggleMenu, closeMenu } = frontPageSlice.actions;
export default frontPageSlice.reducer;